"use strict";

var device = {
  agent: navigator.userAgent.toLocaleLowerCase(),
  os: null,
  ver: null,
  init: function init() {
    if (device.agent.indexOf('iphone') > -1 || device.agent.indexOf('ipad') > -1) {
      var str = device.agent.substring(device.agent.indexOf('os') + 3);
      var ver = str.substring(0, str.indexOf(' like'));
      device.os = 'ios';
      device.ver = device.os + ver;
    }

    if (device.agent.indexOf('android') > -1) {
      var _str = device.agent.substring(device.agent.indexOf('android') + 8);

      var strSub = _str.substring(0, _str.indexOf(';'));

      var _ver = strSub.replace(/[.]/gi, '_');

      device.os = 'android';
      device.ver = device.os + _ver;
    }

    device.set();
  },
  set: function set() {
    var html = document.querySelector('html');
    var htmlClass = html.getAttribute('class');
    var trash = '';
    if (device.agent.indexOf('samsung') > -1) trash += ' samsung';
    if (device.agent.indexOf('naver') > -1) trash += ' naver';
    htmlClass ? html.setAttribute('class', htmlClass + ' ' + device.ver + trash) : html.setAttribute('class', device.ver + trash);
  }
};
var findEl = {
  obj: null,
  parent: function parent(el, str) {
    var tag = el.parentNode.tagName.toLowerCase();
    var cls = el.parentNode.classList;
    var id = el.parentNode.getAttribute('id');
    findEl.obj = el.parentNode;

    if (str !== tag && !cls.contains(str) && str != id) {
      if (tag != 'body') {
        findEl.parent(findEl.obj, str);
      } else {
        findEl.obj = null;
      }
    }

    return findEl.obj;
  },
  child: function child(el, str) {
    var arr = [];
    [].forEach.call(el.childNodes, function (obj) {
      if (obj.nodeType == 1) {
        var tag = obj.tagName.toLowerCase();
        var cls = obj.classList;
        var id = obj.getAttribute('id');

        if (str === tag || cls.contains(str) || str === id) {
          arr.push(obj);
        }
      }
    });

    if (arr.length > 0) {
      return arr;
    } else {
      return null;
    }
  },
  prevNode: function prevNode(str) {
    if (str.previousSibling != null) {
      if (str.previousSibling.nodeType == 1) {
        findEl.obj = str.previousSibling;
      } else {
        findEl.prevNode(str.previousSibling);
      }

      return findEl.obj;
    }
  },
  nextNode: function nextNode(str) {
    if (str.nextSibling != null) {
      if (str.nextSibling.nodeType == 1) {
        findEl.obj = str.nextSibling;
      } else {
        findEl.nextNode(str.nextSibling);
      }

      return findEl.obj;
    }
  }
};

var getUrlParams = function getUrlParams() {
  var params = {};
  window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
    params[key] = value;
  });
  return params;
};

window.addEventListener('DOMContentLoaded', function () {
  device.init();
}); // Main UI 

$(function () {
  // 기본 UI컴포넌트들에 대한 스크립트 처리
  $('label.select > select').selectric();

  function gnbSubMore() {
    if ($('.gnb-menu .depth2-menu').children('ul').hasClass('depth3-list')) {
      $('.depth2-menu > a').each(function () {
        if ($(this).next('ul').length > 0) {
          $(this).addClass('more');
        }
      });
    }
  }

  gnbSubMore(); // main visual slide number

  var mainVisual = function mainVisual() {
    $('.main-visual-wrap .swiper-slide').each(function (idx) {
      $(this).addClass('visual-slide' + (idx + 1));
    });
  };

  mainVisual(); // main visual slide

  var mainVisualWrap = $('.main-visual-wrap');
  var mainVisualSlide = new Swiper(mainVisualWrap, {
    init: false,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    keyboard: {
      enabled: true
    },
    pagination: {
      el: '.swiper-pagination',
      type: "fraction",
      clickable: true
    },
    navigation: {
      prevEl: ".btn-swiper-arrow.prev",
      nextEl: ".btn-swiper-arrow.next"
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    resistance: '100%',
    resistanceRatio: 0
  });
  mainVisualSlide.init();
  /* 20210524 삭제 */

  /* $(".main-visual-wrap .btn-swiper-arrow.play").on('click', function(){
  	mainVisualSlide.autoplay.start();
  })
  $(".main-visual-wrap .btn-swiper-arrow.pause").on('click', function(){
  	mainVisualSlide.autoplay.stop();
  }) */

  /* 20210524 추가 */

  var mainVisualBtn = function mainVisualBtn() {
    $('.main-visual-wrap .btn-swiper-arrow.pause').on('click', function () {
      $(this).toggleClass("play_active");

      if ($(this).hasClass('play_active')) {
        mainVisualSlide.autoplay.stop();
      } else {
        mainVisualSlide.autoplay.start();
      }
    });
  };

  mainVisualBtn(); // main banner 공지사항

  var mainNoticeSlide = new Swiper('.main-banner-notice', {
    init: false,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    keyboard: {
      enabled: true
    },
    navigation: {
      prevEl: ".btn-swiper-arrow.prev",
      nextEl: ".btn-swiper-arrow.next"
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    resistance: '100%',
    resistanceRatio: 0
  });
  mainNoticeSlide.init();
  /* 20210524 삭제 */

  /* $(".main-banner-notice .btn-swiper-arrow.play").on('click', function(){
  	mainNoticeSlide.autoplay.start();
  })
  $(".main-banner-notice .btn-swiper-arrow.pause").on('click', function(){
  	mainNoticeSlide.autoplay.stop();
  }) */

  /* 20210524 추가 */

  var mainBannerNoticeBtn = function mainBannerNoticeBtn() {
    $('.main-banner-notice .btn-swiper-arrow.pause').on('click', function () {
      $(this).toggleClass("play_active");

      if ($(this).hasClass('play_active')) {
        mainNoticeSlide.autoplay.stop();
      } else {
        mainNoticeSlide.autoplay.start();
      }
    });
  };

  mainBannerNoticeBtn(); // main gnb 

  var newGnb = $('#new-gnb');
  var slogan = $('.gnb-menu > .slogan');
  var depth1 = $('.depth1-list > li');
  var depth2 = $('.depth2-list > li');
  var depth1link = $('.depth1-list > li > a');
  var depth2link = $('.depth2-list > li > a');
  var mobileWidth = 767;
  depth1.on('mouseover', function () {
    if (window.innerWidth > mobileWidth) {
      depth1.not($(this)).find(".depth2-list").hide();
      depth1.not($(this)).find(".sub-depth-wrap").hide();
      $(this).find(".depth2-list").show();
      $(this).find(".sub-depth-wrap").show();
      slogan.show();
    }
  });
  newGnb.on('mouseout', function () {
    if (window.innerWidth > mobileWidth) {
      $(".depth2-list").hide();
      $('.sub-depth-wrap').hide();
      slogan.hide();
    }
  });
  depth1link.on('click', function () {
    if (window.innerWidth <= mobileWidth) {
      depth1.not($(this).parent()).find(".depth2-list").hide();
      depth1.not($(this).parent()).find(".sub-depth-wrap").hide();
      $(this).parent().find(".depth2-list").show();
      $(this).parent().find(".sub-depth-wrap").show();
      depth1link.removeClass('active');
      $(this).addClass('active');
    }
  });
  depth2link.on('click', function () {
    if (window.innerWidth <= mobileWidth) {
      if ($(this).parent().hasClass('open')) {
        $(this).parent().removeClass('open');
      } else {
        $(this).parent().addClass('open');
      }
    }
  });
  $('.btn-all-menu').on('click', function () {
    $('.gnb-wrap').addClass('open');

    if (isMobileScreen) {
      depth1link.each(function () {
        var isActive = false;

        if ($(this).hasClass('active')) {
          isActive = true;
          $(this).parent().find(".depth2-list").show();
          $(this).parent().find(".sub-depth-wrap").show();
        }

        if (!isActive) {
          depth1link.eq(0).addClass('active');
          depth1link.eq(0).parent().find(".depth2-list").show();
          depth1link.eq(0).parent().find(".sub-depth-wrap").show();
        }
      });
    }
  });
  $('.btn-all-close').on('click', function () {
    $('.gnb-wrap').removeClass('open');
  });
  var isMobileScreen = window.innerWidth > mobileWidth ? false : true;
  $(window).resize(function () {
    if (window.innerWidth > mobileWidth) {
      // PC
      if (isMobileScreen) {
        console.log('pc');
        depth1link.removeClass('active');
        depth1link.blur();
      }

      isMobileScreen = false;
    } else {
      // 모바일
      if (!isMobileScreen) {
        $('.gnb-wrap').removeClass('open');
      }

      isMobileScreen = true;
    }
  });
  siteLink();

  function siteLink() {
    $('.site-link > a').on('mouseover click', function () {
      $(this).next('ul').addClass('open');
      return false;
    });
    $('.site-link').on('mouseleave click', function () {
      $('.site-link > ul').removeClass('open');
      return false;
    });
  }
});